import { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Grid, List } from '@mui/material';
import block from 'bem-cn';
import { observer } from 'mobx-react';

import { dashboardStore, charactersStore } from 'stores';
import { StatisticsTable } from 'pages/DashboardPage/components/StatisticsComponent/components';
import BoxPlotChart from 'pages/DashboardPage/components/StatisticsComponent/components/BoxPlotChart';
import Loader from 'components/CommonComponents/Loader';

import './Gestures.scss';

const cnGestures = block('Gestures');

function Gestures({ setOpen }: any) {
  const processFullBody = () => {
    if (!charactersStore.characterDataCSV) return;

    charactersStore.isLoading = true;

    // 🔹 Загружаем все CSV и Gesture данные для полного тела
    Object.keys(charactersStore.characterDataCSV).forEach((key) => {
      if (key.startsWith('gesture_')) {
        // Gesture
        dashboardStore.GestureLoader.parseGestureData(charactersStore.characterDataCSV[key]);
      } else {
        // CSV
        dashboardStore.dataLoader.openJsonFile();
        dashboardStore.dataLoader.openJsonFile(charactersStore.characterDataCSV[key]);
      }
    });

    // 🔹 Обновляем stats
    dashboardStore.setStats(charactersStore.characterDataCSV['stats_full'] || {});

    // 🔹 Обработка gesture для Radar Chart (если есть)
    if (charactersStore.characterDataGesture) {
      const allValues = Object.values(charactersStore.characterDataGesture)
          .map((v) => parseInt(v as string))
          .filter((v) => !isNaN(v))
          .sort((a, b) => b - a);

      dashboardStore.setSizeRadarChartValue(allValues[0] || 0);
      dashboardStore.setSelectedGesture('full_body', []); // заглушка
    }

    charactersStore.isLoading = false;
  };

  useEffect(() => {
    processFullBody();
  }, [charactersStore.characterDataCSV]);

  return (
      <Box sx={{ width: '60rem' }} role="presentation">
        <CloseIcon className="closeicon" onClick={() => setOpen(false)} />
        <List sx={{ paddingTop: 0 }}>
          {charactersStore.isLoading && <Loader visible />}
          <div className={cnGestures()}>
            <Grid item xs={12} className="item" height="100%">
              <StatisticsTable
                  tab="gesture"
                  columnsNames={!!Object.keys(dashboardStore.GestureLoader2.data).length
                      ? ['Жест', `Медиана За первую дату`, 'За среднюю дату', 'За последнюю дату']
                      : ['Жест', 'Медиана']}
              />
            </Grid>
            {!!charactersStore.characterDataCSV && <BoxPlotChart />}
          </div>
        </List>
      </Box>
  );
}

export default observer(Gestures);
